document.addEventListener('DOMContentLoaded', function () {
  const selectYear = document.getElementById('artists-y');

  if (selectYear) {
    selectYear.addEventListener('change', function () {
      const value = this.value;
      const url = new URL(window.location.href);

      if (value) {
        url.searchParams.set('y', value);
      } else {
        url.searchParams.delete('y');
      }

      window.location.href = url.toString();
    });
  }
});
